import typeToReducer from 'type-to-reducer'
export default typeToReducer({}, {})
